module.exports = __webpack_public_path__ + "static/media/watch.4a9c6149.png";